module.exports = __webpack_public_path__ + "img/hair_front_female_middle_part_mask.8e643c15.png";